import axios, { AxiosError } from "axios";

export function handleAxiosError(error: unknown): string {
  const axiosError = error as AxiosError;

  if (axiosError.response) {
    const responseData = axiosError.response.data as any;
    return (
      responseData?.message ||
      responseData?.error ||
      axiosError.message ||
      "Server error occurred"
    );
  } else if (axiosError.request) {
    return "Network error - please check your connection";
  } else {
    return axiosError.message || "Request setup error";
  }
}

export function handleError(error: unknown): string {
  // Handle Axios errors
  if (axios.isAxiosError(error)) {
    return handleAxiosError(error);
  }

  // Handle standard JavaScript errors
  if (error instanceof Error) {
    return error.message || "An unexpected error occurred";
  }

  // Handle string errors
  if (typeof error === "string") {
    return error;
  }

  // Handle unknown errors
  return "An unknown error occurred";
}
